import type { ComponentProps, ReactNode } from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const messageVariants = tv({
  base: "mx-auto flex w-full flex-col items-start gap-x-3 gap-y-1.5 bg-white p-5",
  variants: {
    type: {
      success: "bg-green-50 border border-green-200 text-green-900",
      warning: "bg-amber-50 border border-amber-200 text-amber-900",
      error: "bg-red-50 border border-red-200 text-red-900",
    },
    hasIcon: {
      true: "flex-row",
      false: "flex-col",
    },
  },
  defaultVariants: {
    hasIcon: false,
    typep: "error",
  },
});

type MessageProps = ComponentProps<"div"> &
  VariantProps<typeof messageVariants> & {
    icon?: ReactNode;
  };

export function Message({
  children,
  className,
  type,
  icon,
  ...props
}: MessageProps) {
  const hasIcon = Boolean(icon);

  return (
    <div className={messageVariants({ type, hasIcon, className })} {...props}>
      {icon}
      <div className="flex flex-col gap-1">{children}</div>
    </div>
  );
}
